import { gql } from '@apollo/client/core'

export const ATTRIBUTES_FRAGMENT = gql`
  fragment Attributes on AttributesWrapper {
    ... on AttributesOutput {
      attributes {
        id
        name
        icon
      }
    }
    ...ServerError
    ...UnauthenticatedError
    ...UnauthorizedError
  }
`
